/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em",
    strong: "strong",
    h3: "h3",
    p: "p",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Events"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Events"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "on_change"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " will be called on state changes made by the user. Returns an object with the new selected ", _jsx(_components.code, {
              children: "data"
            }), " item ", _jsx(_components.code, {
              children: "{ data, event, attributes, value }"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "on_select"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " will be called once the user focuses or selects an item by a click or keyboard navigation. Returns an object with the new selected ", _jsx(_components.code, {
              children: "data"
            }), " item ", _jsx(_components.code, {
              children: "{ data, event, attributes, value, active_item }"
            }), ". The ", _jsx(_components.strong, {
              children: "active_item"
            }), " property is the currently selected item by keyboard navigation"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "on_show"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " will be called once the user presses the dropdown. Returns the data item ", _jsx(_components.code, {
              children: "{ data, attributes }"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "on_hide"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " will be called once the user presses the dropdown again, or clicks somewhere else. Returns the data item ", _jsx(_components.code, {
              children: "{ data, attributes }"
            }), "."]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.h3, {
      children: ["The ", _jsx(_components.code, {
        children: "on_change"
      }), " vs ", _jsx(_components.code, {
        children: "on_select"
      }), " difference"]
    }), "\n", _jsxs(_components.p, {
      children: ["The difference between ", _jsx(_components.code, {
        children: "on_change"
      }), " and ", _jsx(_components.code, {
        children: "on_select"
      }), " is:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "on_change"
        }), " will be called when the state changes, either with a ", _jsx(_components.strong, {
          children: "click"
        }), " or ", _jsx(_components.strong, {
          children: "space/enter"
        }), " keypress confirmation."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "on_select"
        }), " differs most when the user is navigating by keyboard. Once the user is pressing e.g. the arrow keys, the selection is changing, but not the state."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
